export const pad0xBegin = (str) => {
    return str.startsWith("0x") ? str : `0x${str}`;
};
